export default __webpack_public_path__ + "static/media/ebud.f210bc43.svg";